const sendRequest = async (data) => {
    try {
      const url = `${window.appConfig.sendRequest}${window.appConfig.TokenRelam}/${
        window.appConfig.clientId
      }/${window.appConfig.clientSecret}`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        if (response.status === 409) {
          throw "Consumer user already exist.";
        }
        const errorData = await response.json();
        throw errorData;
      }
  
      const result = await response.json();
      return result;
    } catch (e) {
      if (typeof e === "string") {
        throw e; // already handled above
      } else {
        throw "Internal server error, please try again.";
      }
    }
  };

  export default {sendRequest}